/* eslint-disable no-undef */
export default {
	name: "delivery-orders",
	data() {
		return {
            company: {},
			orders: [],
			orderStatuses: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			deliveryOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer", 
					field: "registeredCompanyName"
				},
				{
					text: "Order Type",
					field: "orderType"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Date Of Delivery",
					field: "expectedDeliveryDate"
				},
				{
					text: "Date Delivered",
					field: "dateDelivered"
				},
				{
					text: "Vehicle",
					field: "vehicle"
				},
				{
					text: "Driver",
					field: "driver"
				},
				// {
				// 	text: "Fleet Number",
				// 	field: "fleetNumber"
				// },
				// {
				// 	text: "Amount Ordered",
				// 	field: "quantity"
				// },
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			actionKeys:{
				viewOrder: "viewOrder",
				viewTrackingHistory: "viewTrackingHistory",
				rescheduleOrder: "rescheduleOrder",
				documents: "documents",
				orderEnquiries: "orderEnquiries"
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: 1,
				companyId: null,
				orderStatusId: null
			},
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			shippingAddressSelectModal:{
				modalId: "selectShippingAddressForOrderModal",
				heading: "Select Shipping Address For Order",
				showModal: false,
				company: null
			},
			initialiseExpectedDate: true,
			rescheduleOrderModal:{
				modalId: "rescheduleOrderModal",
				heading: "Reschedule Order",
				showModal: false,
				isSaving: false,
				orderId: null,
				orderDeliveryId: null,
				orderDeliveryScheduleId: null,
				expectedDateOfDelivery: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null
			},
			shippingAddressSelectedForOrder: null,
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			orderForDeliveryModal: {
				modalId: "createOrderForDeliveryModal",
				heading: "Create New Order For Delivery",
				showModal: false,
				companyId: null
			},
			hasLoaded: false,
			loading: false
		};
	},
	methods: {
        getCompany(){
            customerService.getCompany().then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.company = successResponse.data.result;
                    }
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    alert("Unexpected error occurred");
                }
            );
        },
		getDeliveryOrders(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				orderStatusId: this.filter.orderStatusId,
				createdFrom: this.filter.fromDateCreated,
				createdTo: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			orderService.getOrdersForDelivery(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orders = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.orders.length; i++){
							if(this.orders[i].discountedAmount !== null){
								this.orders[i].totalAmount = this.orders[i].totalAmount - this.orders[i].discountedAmount;
							}
							if (this.orders[i].orderStatusId === orderHelper.orderStatus.complete) {
								this.orders[i].dateDelivered = this.orders[i].statusLastUpdatedOn;
							}
							this.orders[i].totalAsString = currencyHelper.numberToCurrency(this.orders[i].totalAmount);
							this.orders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnDeliveryOrdersViewOrder"
								},
								{
									name: "View Tracking History",
									key: this.actionKeys.viewTrackingHistory,
									elementId: "btnDeliveryOrdersViewTrackingHistory"
								}
							];
							if(this.orders[i].orderStatusId === orderHelper.orderStatus.pending || this.orders[i].orderStatusId === orderHelper.orderStatus.accepted) {
								this.orders[i].actions.push({
									name: "Reschedule Order",
									key: this.actionKeys.rescheduleOrder,
									elementId: "btnDeliveryOrdersRescheduleOrder"
								});
							}
							if(this.orders[i].orderStatusId === orderHelper.orderStatus.complete) {
								this.orders[i].actions.push(
									{
										name: "Documents",
										key: this.actionKeys.documents,
										elementId: "btnOrdersViewDocuments"
									}
								);
							}
							else {
								this.orders[i].actions.push(
									{
										name: "Order Enquiries",
										key: this.actionKeys.orderEnquiries,
										elementId: "btnOrdersOrderEnquiries"
									}
								);
							}
						}
						this.orders = dataTableHelper.castFieldValues(this.orders);
						this.hasLoaded = true;
						this.filterStateChanged = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					alert("Unexpected error occurred");
				}
			);
		},
		getOrderStatuses(){
			this.orderStatuses = orderService.getDeliveryOrderStatuses();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({id: 0, text: "All"});
			this.filter.orderStatusId = this.orderStatuses[0].id;
			this.getDeliveryOrders();
		},
		onFilterSearchClicked(){
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getDeliveryOrders();
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getDeliveryOrders();
		},
		onOrderStatusSelect(orderStatus){
			if(orderStatus.id !== this.filter.orderStatusId){
				this.filter.orderStatusId = orderStatus.id;
				this.filterStateChanged = true;
			}
			//this.filter.orderStatusId = orderStatus.id;
			console.log("order status change");
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
		},
		onOrderActionClicked(actionAndData){
			switch(actionAndData.action) {
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId);
					break;
				case this.actionKeys.viewTrackingHistory:
					this.trackingHistoryModal.showModal = true;
					this.trackingHistoryModal.orderId = actionAndData.data.orderId;
					this.trackingHistoryModal.heading = "Tracking History - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
				case this.actionKeys.rescheduleOrder:
					this.rescheduleOrderModal.showModal = true;
					this.rescheduleOrderModal.orderId = actionAndData.data.orderId;
					this.rescheduleOrderModal.orderDeliveryId = actionAndData.data.orderDeliveryId;
					this.rescheduleOrderModal.orderDeliveryScheduleId = actionAndData.data.orderDeliveryScheduleId;
					this.trackingHistoryModal.heading = "Reschedule Order - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					var self = this;
					console.log("expectedDeliveryDate", actionAndData.data.expectedDeliveryDate);
					setTimeout(function () {
						console.log("date", moment(actionAndData.data.expectedDeliveryDate, 'DD/MM/YYYY', true).format());
						self.initialiseExpectedDate = true;
						self.rescheduleOrderModal.expectedDateOfDelivery.value = moment(actionAndData.data.expectedDeliveryDate, 'DD/MM/YYYY', true).format()
					}, 500);
					break;
				case this.actionKeys.documents:
					this.documentsModal.showModal = true;
					this.documentsModal.orderId = actionAndData.data.orderId;
					this.documentsModal.heading = "Order Documents - #" + actionAndData.data.orderId;
					break;
				case this.actionKeys.orderEnquiries:
					this.$router.push("/orders/orderEnquiryMessages/" + actionAndData.data.orderId + "/" + orderHelper.orderType.delivery + "/" + actionAndData.data.orderStatusId);
					break;
			}
		},
		onRescheduleOrderOkClicked(){
			this.rescheduleOrderModal.showModal = false;
		},
		onRescheduleOrderSaveClicked() {
			this.rescheduleOrderModal.isSaving = true;
			let request = {
				orderId: this.rescheduleOrderModal.orderId,
				orderDeliveryId: this.rescheduleOrderModal.orderDeliveryId,
				expectedDeliveryDate: this.rescheduleOrderModal.expectedDateOfDelivery.value
			};
			orderService.rescheduleOrderDeliverySchedule(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						if(successResponse.data.rescheduleDeliveryOrderValidationResponse.valuesAreValid) {
							this.getDeliveryOrders();
							this.rescheduleOrderModal.showModal = false;
						}
						else{
							this.rescheduleOrderModal.expectedDateOfDelivery.hasError = successResponse.data.rescheduleDeliveryOrderValidationResponse.expectedDateOfDeliveryValidationResponse.hasError;
							this.rescheduleOrderModal.expectedDateOfDelivery.errorMessage = successResponse.data.rescheduleDeliveryOrderValidationResponse.expectedDateOfDeliveryValidationResponse.message;
						}
					}
					this.rescheduleOrderModal.isSaving = false;
				},
				errorResponse => {
					this.rescheduleOrderModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onRescheduleDateSelected(date){
			this.rescheduleOrderModal.expectedDateOfDelivery.value = date;
			console.log("expectedDateOfDelivery1", this.rescheduleOrderModal.expectedDateOfDelivery.value);
			this.initialiseExpectedDate = false;
		},
		onShippingAddressSelected(shippingAddress){
			console.log("shippingAddress1", shippingAddress);
			this.shippingAddressSelectedForOrder = shippingAddress;
			this.shippingAddressSelectModal.showModal = false;
			var self = this;
			setTimeout(function(){
				self.orderForDeliveryModal.company = self.shippingAddressSelectModal.company;
				self.orderForDeliveryModal.showModal = true;
			}, 500);
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		onAddOrderClick(){
			//this.orderForDeliveryModal.showModal = true;
			this.shippingAddressSelectModal.showModal = true;
		},
		onPlaceOrderForDeliveryOkClicked(){
			this.orderForDeliveryModal.showModal = false;
			this.getDeliveryOrders();
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		},
	},
	mounted: function () {
        this.getCompany();
		this.filter.orderStatusId = orderHelper.orderStatus.pending;
		console.log("orderStatusId", this.filter.orderStatusId)
		this.getOrderStatuses();
		storeState.setPageTitleAction("Orders - Delivery");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Orders - Delivery");
	}
};